// extracted by mini-css-extract-plugin
export default {"description":"description_description__oyhs0","title":"description_title__W7Gm-","strongy":"description_strongy__stdi6","text":"description_text__MQRsy"};